var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c('Spinner'):_c('img',{staticClass:"ml-3 pointer",attrs:{"src":"/assets/img/icons/download.png","alt":"Download as csv","width":"30px"},on:{"click":_vm.downloadReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }